<template>
<div class="chapter">
<div class="inner_page">
<div id="fm7">
<a id="pagevii">
<p class="ind2"><em class="italic">A Free Man of Color</em> was commissioned and produced by the Lincoln Center Theater at the Vivian Beaumont, New York, New York, under the direction of André Bishop and Bernard Gersten. It opened in December 2010 with the following cast:</p>
<p class="ind1"><span class="bold1">JACQUES CORNET</span><span class="indtxt">Jeffrey Wright</span></p>
<p class="ind1"><span class="bold1">CUPIDON MURMUR AND TOUSSAINT LOUVERTURE</span><span class="indtxt">Mos</span></p>
<p class="ind1"><span class="bold1">ZEUS-MARIE PINCEPOUSSE AND TALLYRAND</span><span class="indtxt">Reg Rogers</span></p>
<p class="ind1"><span class="bold1">MARGERY JOLICOEUR</span><span class="indtxt">Nicole Beharie</span></p>
<p class="ind1"><span class="bold1">DR. TOUBIB</span><span class="indtxt">Joseph Marcell</span></p>
<p class="ind1"><span class="bold1">JUAN VENTURA MORALES AND NAPOLEON BONAPARTE</span><span class="indtxt">Triney Sandoval</span></p>
<p class="ind1"><span class="bold1">DOÑA SMERALDA AND JOSEPHINE</span><span class="indtxt">Justina Machado</span></p>
<p class="ind1"><span class="bold1">ORPHEE</span><span class="indtxt">Esau Pritchett</span></p>
<p class="ind1"><span class="bold1">LEDA, MME. DORILANTE, AND MELPOMENE</span><span class="indtxt">Teyonah Parris</span></p>
<p class="ind1"><span class="bold1">DOÑA ATHENE AND CALLIOPE</span><span class="indtxt">Sara Gettelfinger</span></p>
<p class="ind1"><span class="bold1">REMY DORILANTE AND JAMES MONROE</span><span class="indtxt">Arnie Burton</span></p>
<p class="ind1"><span class="bold1">JONATHAN SPARKS AND MAJOR WALTER REED</span><span class="indtxt">Brian Reddy</span></p>
<p class="ind1"><span class="bold1">MRS. SPARKS, TERPSICHORE, AND THE INFANTA</span><span class="indtxt">Rosal Colón</span></p>
<p class="ind1"><span class="bold1">LORD HARCOURT, LE CLERC’S CAPTAIN, AND GEORGES FEYDEAU</span><span class="indtxt">Robert Stanton</span></p>
<p class="ind1"><span class="bold1">LADY HARCOURT AND EUTERPE</span><span class="indtxt">Wendy Rich Stetson</span></p>
<p class="ind1"><span class="bold1">ALCIBIADE</span><span class="indtxt">David Emerson Toney</span></p>
<p class="ind1"><span class="bold1">PYTHAGORE, GENERAL LE CLERC AND KING CARLOS CUARTO</span><span class="indtxt">Nick Mennell</span></p>
<p class="ind1"><span class="bold1">MERCURE AND COUNT ACHILLE CREUX</span><span class="indtxt">Peter Bartlett</span></p>
</a><a id="pageviii">
<p class="ind1"><span class="bold1">MME. MANDRAGOLA, DOÑA POLISSENA, AND ROBERT LIVINGSTON</span><span class="indtxt">Veanne Cox</span></p>
<p class="ind1"><span class="bold1">THOMAS JEFFERSON</span><span class="indtxt">John McMartin</span></p>
<p class="ind1"><span class="bold1">MERIWETHER LEWIS</span><span class="indtxt">Paul Dano</span></p>
<p class="ind3"><em class="italic">Director</em><span class="indtxt">George C. Wolfe</span></p>
<p><em class="italic">Sets</em><span class="indtxt">David Rockwell</span></p>
<p><em class="italic">Costumes</em><span class="indtxt">Ann Hould-Ward</span></p>
<p><em class="italic">Lighting</em><span class="indtxt">Jules Fisher and Peggy Eisenhauer</span></p>
<p><em class="italic">Sound</em><span class="indtxt">Scott Stauffer</span></p>
<p><em class="italic">Original Music</em><span class="indtxt">Jeanine Tesori</span></p>
<p class="ind4"><em class="italic">Choreography</em><span class="indtxt">Hope Clarke</span></p>
<p class="ind3">The play is set in New Orleans, 1801–1806, and other locations in Europe and America.</p>
<p class="ind3">In the New World at this time, there was a vocabulary of more than a hundred terms for people of mixed race, extending back seven generations in an individual’s heritage. For example: “pure” white and “pure” black = mulatto; mulatto and black = sambo; mulatto and white = quadroon; a mamelouc was “113 of 120 parts white,” etc.</p>
</a></div><a id="pageviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802195005_fm.vue?4c860cfe